<template>
    <div class="container">
        <div class="book_list_box">
            <template v-if="detail&&detail.length">
                <ul class="book_list dflex">
                    <li class="book_item" v-for="item in detail" :key="item.id">
                        <nuxt-link :to="'/'+$route.params.nav+'/'+$route.params.channel+'/'+$route.params.subid+'/prodetail/'+item.id" target="_blank">
                            <dl class="book_item_conent tac">
                                <dt class="book_item_conent_dt dflex"><img :src="$store.state.imgurl+item.imagePath" alt=""></dt>
                                <dd class="book_item_conent_dd"><div class="cdiv" v-html="item.title"></div></dd>
                            </dl>
                        </nuxt-link>
                    </li>
                </ul>
            </template>
            <template v-else>
                <nothing></nothing>
            </template>
            <template v-if="detail.length && pages < pageNum.totalPages">
                <div class="loadmore tac cp" @click="getMoreFn">加载更多</div>
            </template>
            <template v-if="pages >= pageNum.totalPages && pageNum.totalPages>0">
                <div class="loadmore tac">已加载全部</div>
            </template>
        </div>
    </div>
</template>
<script>
import { getRichPage} from '~/until/http.js'
import nothing from '~/components/nothing.vue'
export default {
    data (){
        return {
            pages: 1,
            ismore: true
        }
    },
    components: {
        nothing
    },
    async asyncData({isDev, route, store, env, params, query, req, res, redirect, error}) {
        let cont = await getRichPage(params.subid, 0)
        return {
            detail: cont.content,
            pageNum: cont.page
        }
    },
    mounted(){
        getRichPage(this.$route.params.subid, 0).then(res => {
            console.log(res)
        })
    },
    methods: {
        getMoreFn (){
            getRichPage(this.$route.params.subid,this.pages).then(res => {
                
                this.detail = this.detail.concat(res.content)
                this.pages++
                
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.loadmore{
    width: 100px;
    line-height: 34px;
    background-color: #F6F6F6;
    margin: 30px auto;
    color: #F7941D;
}
.book_list_box{
    padding: 0 40px;
}
.book_item_conent_dd{
    font-size: 12px;
    color: #333;
    transition: all 0.3s;
    border-top: 1px solid #F1F1F1;
    padding: 10px 22px;
    line-height: 22px;
    .cdiv{
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2; 
        /*! autoprefixer: ignore next */
        -webkit-box-orient: vertical;
        height: 44px;
    }
    
}
.book_item_conent_dt{
    height: 228px;
    overflow: hidden;
    justify-content: center;
    align-items: center;
    img{
        max-width: 100%;
        max-height: 100%;
    }
}
.book_list{
    flex-wrap: wrap;
    margin-left: -16px;
    margin-right: -16px;
}
.book_item_conent{
    border: 1px solid #F1F1F1;
    transition: all 0.3s;
    &:hover{
        box-shadow: 0 3px 6px 0 rgba(0,0,0,0.08);
        .book_item_conent_dd{
            font-weight: bold;
            color: #F7941D;
        }
    }
}
.book_item{
    width: 25%;
    padding: 0 16px;
    box-sizing: border-box;
    margin-top: 20px;
}
</style>
